import { SVGELEMENT } from '../../../../enums/SVGELEMENT.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import SVGFILTER, { svgFilter } from '../../../DOM/svg/SVGOBJECT/SVGDEFS/SVGFILTER.js';
import EL from '../../../EL/EL.js';
// Model Structure
export const svgDefsAttr = makeAttrStruct([]);
export const svgDefsData = makeDataStruct([
    ['children', []]
]);
export const svgDefsModel = makeStruct([
    ['attributes', svgDefsAttr],
    ['data', svgDefsData]
]);
// Simplified Model
export function svgDefs(attributes, data) {
    return {
        attributes: attributes || svgDefsAttr(),
        data: data || svgDefsData()
    };
}
/** Creates a Definition container for an SVG */
export default class SVGDEFS extends EL {
    constructor(node, model) {
        super(node, SVGELEMENT.DEFS, model);
        this.buildSVGFilter(model.data.children ?? []);
    }
    // /** Creates the DOM HTMLElement during instantiation
    //  * Override this method to create a custom element
    //  */
    createElement() {
        const el = document.createElementNS('http://www.w3.org/2000/svg', this.element);
        return el;
    }
    buildSVGFilter(vectors) {
        vectors.forEach((vector) => {
            switch (vector.element) {
                case SVGELEMENT.FILTER:
                    this.addFilter(svgFilter(vector.id, vector.x, vector.y));
                    break;
                case SVGELEMENT.DEFS:
                    this.addDefs(svgDefs());
                    break;
                default:
                    console.warn('SVGDEFS.buildSVGFilter: vector.element is undefined', vector);
                    break;
            }
        });
    }
    /** Adds a defs element to this DEFS Element */
    addDefs(model) {
        return this.addChild(new SVGDEFS(this, model));
    }
    /** Adds a filter element to this DEFS Element */
    addFilter(model) {
        return this.addChild(new SVGFILTER(this, model));
    }
}
